"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingStyled = void 0;

var _utils = require("../../utils");

var _const = require("../../const");

var _const2 = require("./const");

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var measureSize = function measureSize(measure) {
  return (0, _const.map)(measure, function (s) {
    return "font-size: ".concat(_const2.HeadingSize[s], ";");
  });
};

var tagStyle = function tagStyle(tag) {
  return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), _const2.HeadingSize[tag]);
};

var HeadingStyled = (0, _utils.styled)('h1')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  margin: 0;\n  padding: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.$fontSize ? (0, _const.fontSizeHelperStyle)(props.$fontSize) : props.measure && measureSize(props.measure) || tagStyle(props.as);
}, function (_ref) {
  var $color = _ref.$color;
  return _const.Colors[$color];
}, function (props) {
  return props.lineHeight && (0, _const.lineHeightHelperStyle)(props.lineHeight);
}, function (props) {
  return props.$letterSpacing && (0, _const.letterSpacingHelperStyle)(props.$letterSpacing);
}, function (props) {
  return props.uppercase && (0, _utils.uppercase)();
}, function (props) {
  return props.lowercase && (0, _utils.lowercase)();
}, function (props) {
  return props.lineThrough && (0, _utils.lineThrough)();
}, function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref2) {
  var align = _ref2.align;
  return align && (0, _const.alignHelperStyle)(align);
}, function (_ref3) {
  var $fontWeight = _ref3.$fontWeight;
  return $fontWeight && (0, _const.fontWeightHelperStyle)($fontWeight);
}, function (_ref4) {
  var $fontFamily = _ref4.$fontFamily;
  return $fontFamily && (0, _const.fontFamilyHelperStyle)($fontFamily);
}, function (_ref5) {
  var $display = _ref5.$display;
  return $display && (0, _const.displayHelperStyle)($display);
});
exports.HeadingStyled = HeadingStyled;